import './App.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import Menu from './components/menu/Menu';
import Banner from './components/banner/Banner';
import SecondSection from './components/secondSection/SecondSection';
import ThirdSection from './components/thirdSection/ThirdSection';
import FourthSection from './components/fourthSection/FourthSection';
import StatsSection from './components/StatsSection';
import Courses from './components/Courses';
import TestimonialSection from './components/TestimonialSection';
import VerseCard from './components/versecard/VerseCard';
import ContactSection from './components/contact/ContactSection';
import FooterSection from './components/footer/FooterSection';
import WhatsAppButton from './components/whatapp/WhatsAppButton';

function App() {
  return (
    <>
      <div className='menu1'><Menu /></div>
      <div id="home"><Banner /></div>
      <SecondSection />
      <ThirdSection />
      <StatsSection /><br /><br /><br />
      <FourthSection />
      <div id="courses"><Courses /></div>
      <div id='reviews'><TestimonialSection /></div>
      <VerseCard />
      <br /><br />
      <div id="contactus"><ContactSection /></div>
      <div id="aboutus"><FooterSection /></div>
      <WhatsAppButton />
    </>
  );
}

export default App;
